import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  createpreauthcode: option =>
    request3('v1/wxapp3party/createpreauthcode' + urlStringify(option), {}, true)
}
